import { queryClient, queryKeys } from '../../lib/query-client';
import ProjectService from '../../service/project-service';
import displayNetworkError from '../../helpers/displayNetworkError';

export const makeMessagesActions = (set, get) => {
    const fetchMessagesImpl = async (projectId, params = {}) => {
        set('messagesLoading', true);
        set('messagesError', null);

        try {
            const pageId = params.pageId ?? 0;
            const data = await queryClient.fetchQuery({
                queryKey: queryKeys.projectMessages(projectId, params.type, pageId),
                queryFn: () => ProjectService.getProjectMessagesAsync(projectId, { ...params, pageId }),
            });

            set('messages', data);
            set('messagesLoading', false);
        } catch (error) {
            set('messagesError', error);
            set('messagesLoading', false);
            displayNetworkError(error);

            if (!error?.handled) {
                throw error;
            }
        }
    };

    return {
        fetchMessages: fetchMessagesImpl,

        sendMessage: async (projectId, body, type) => {
            try {
                await ProjectService.createProjectMessageAsync(projectId, body);

                await queryClient.invalidateQueries({ queryKey: ['project', projectId, 'messages', type] });
                await fetchMessagesImpl(projectId, { type, pageId: 0 });
            } catch (error) {
                displayNetworkError(error);

                if (!error?.handled) {
                    throw error;
                }
            }
        },
    };
};
